module.exports = __webpack_public_path__ + "ea5ed58f858bee68df2481737384b3ce.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/holly-s.png
// module id = 2310
// module chunks = 0